import { createContext } from 'react';

export const HelpModalContext = createContext({
  isHelpModalOpen: false,
  helpModalContent: '',
  openHelpModal: (documentationKey) => {},
  closeHelpModal: () => {},
}); 